// extracted by mini-css-extract-plugin
export var errorBanner = "_e7-2";
export var scroller = "_e7-0";
export var thinking = "_e7-1";
export var visuallyHidden = "_e7-3";